'use strict';

DoohApps
    .service('appStoreBLL', ['AppStoreData', 'AppStoreDataFilter', 'CompanyData', 'Campaign', 'ConfiguratorBlock', 'AppHardwarRequirement',
        function (AppStoreData, AppStoreDataFilter, CompanyData, Campaign, ConfiguratorBlock, AppHardwarRequirement) {
            // App Store ////
            this.GetAppList = function (callback, objectFilterOptions) {
                GetPrices(objectFilterOptions);
                AppStoreData.getAppList(function (data) { setAppStore(callback, data) }, objectFilterOptions);
            }

            this.GetCompanyList = function (callback) {
                CompanyData.getCompanyList(function (data) { returnContent(callback, data) });
            }

            this.GetMarketList = function (callback) {
                AppStoreData.getMarkets(function (data) { returnContent(callback, data) });
            }

            this.GetInteractionTypes = function (callback) {
                AppStoreData.getInteractionTypes(function (data) { returnContent(callback, data) });
            }

            function responseHandler(callback, data) {
                callback({
                    hasError: data.hasError || (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                    error: getErrorMessage(data),
                    message: data.message || (data.Data != undefined ? data.Data.message : null),
                    content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
                });
            }

            function getErrorMessage(data) {
                if (data.hasError)
                    return data.errors[0];

                return data.error_description || data.error || (data.Data != undefined ? data.Data.error : null);
            }

            //-------------------------------------

            this.SendToAppInbox = function (callback, application) {
                var newCampaign = {};
                newCampaign.CampaignTitle = 'New Campaign';
                newCampaign.AppVersionID = application.ApplicationVersionID;
                newCampaign.IsExternal = application.IsExternal;
                Campaign.createCampaign(function (data) { responseHandler(callback, data) }, newCampaign);
            }

            //Callback functions///////
            function setAppStore(callback, data) {
                var res = {
                    hasError: (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined ||  data.hasError,
                    error: data.error_description || data.error || (data.Data != undefined ? data.Data.error : null) || (data.errors != undefined && data.errors.length>0 ? data.errors[0] : null),
                    message: data.message || (data.Data != undefined ? data.Data.message : null),
                    content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
                };
                AppStoreDataFilter.AppStoreFilter.TotalCount = res.content.length != 0 && res.content.length != undefined ? res.content[0].TotalCount : 0;
                callback(res);
            }

            function returnContent(callback, data) {
                if (data.Data != undefined && data.Data.Content != undefined) {
                    callback(data.Data.Content);
                }
                else
                    callback({
                        hasError: (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                        error: data.error_description || data.error || (data.Data != undefined ? data.Data.error : null),
                        message: data.message || (data.Data != undefined ? data.Data.message : null),
                        Content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
                    });
            }

            function GetPrices(objectFilterOptions) {
                objectFilterOptions.PriceStart = 0;
                objectFilterOptions.PriceEnd = 0;
                var spliter = /^>|<|-/;
                var prices = objectFilterOptions.PriceExpression.split(spliter);
                if (prices.length > 1) {
                    if (prices[0] == '') {
                        objectFilterOptions.PriceStart = (objectFilterOptions.PriceExpression.indexOf('>') >= 0) ? parseInt(prices[1]) : 0;
                        objectFilterOptions.PriceEnd = (objectFilterOptions.PriceExpression.indexOf('<') >= 0) ? parseInt(prices[1]) : 0;
                    }
                    else {
                        objectFilterOptions.PriceStart = parseInt(prices[0]);
                        objectFilterOptions.PriceEnd = parseInt(prices[1]);
                    }
                }
            }

            this.GetAppByUrlLink = function (callback, urlLink) {
                AppStoreData.getAppByUrlLink(function (data) { responseHandler(callback, data) }, urlLink);
            }

            this.GetAppByID = function (callback, urlLink) {
                AppStoreData.getAppByID(function (data) { responseHandler(callback, data) }, urlLink);
            }

            this.HasUserUsedApp = function (callback, appID) {
                AppStoreData.hasUserUsedApp(function (data) { responseHandler(callback, data) }, appID);
            }

            this.getAppRequirements = function (callback, appVerID) {
                AppHardwarRequirement.getAppRequirementList(function (data) { returnContent(callback, data) }, appVerID);
            }

            this.getVendorApps = function (callback) {
                AppStoreData.getVendorApps(function (data) { responseHandler(callback, data) });
            }

            this.requestServiceApp = function (callback, requestData) {
                AppStoreData.requestServiceApp(function (data) { responseHandler(callback, data) }, requestData);
            }
        }]);